const JWT = 'jwt'

const init = null

const plugin = store => {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case 'auth/setToken':
        localStorage[JWT] = mutation.payload
        break
      case 'auth/resetToken':
        localStorage.removeItem(JWT)
        break
    }
  })
}

export default plugin
export { init }



// WEBPACK FOOTER //
// ./src/store/plugins/localStorage.js